import React from "react"
const Study = () => {
    return (
        <div id="study" dir="rtl" className="py-20 md:py-44 px-8 bg-brown">
            <h1 className="text-5xl md:text-6xl text-center text-primary font-extrabold mt-2">הרקע וההכשרה שלי</h1>
            <ul className="md:text-2xl list-disc max-w-[800px] px-4 mx-auto mt-8 text-black">
                <li className="mt-2">
                    תואר M.A בייעוץ זוגי ומשפחתי - המכללה למנהל
                </li>
                <li className="mt-2">
                    תואר B.Ed בחינוך - מכללת לוינסקי (התמחות בהבנת צרכי ילדים ופיתוח חינוכי)
                </li>
              
                <li className="mt-2">
                    התמחות בהדרכת הורים ויעוץ משפחתי - פיתוח גישות מותאמות לכל משפחה ולכל ילד
                </li>
                <li className="mt-2">
                    החוויה הדיאלוגית - אוניברסיטת בר אילן
                </li>
                <li className="mt-2">
                    הנחיית קבוצות - מכון אדלר
                </li>
                <li className="mt-2">
                    מנחת חוסן לפי ה CBT בר אילן
                </li>
                <li className="mt-2">
                    EFT ניהול רגש לפי שיטת ההתקשרות בר אילן
                </li>
                <li className="mt-2">
                    משפחות במשבר - בר אילן
                </li>
                <li className="mt-2">
                    הדרכת הורים
                </li>
                <li className="mt-2">
                    קורסים והשתלמויות מתמשכים: מינדפולנס, הדרכת הורים מתקדמת, פיתוח מודעות עצמית, נמרולוגיה, קלפים השלכתיים
                </li>
            </ul>
        </div>
    )
}

export default Study